module.exports = __webpack_public_path__ + "static/zoom-white-35e6dcec4baad871fa703786bf417487.mp4";